<template>
  <PlanRecord :path="'/entrain'"></PlanRecord>
</template>

<script>
  import PlanRecord from '@/page/modules/plan/record'
  export default {
    components: { PlanRecord },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/entrain/plan/record.vue